<template>
    <div class="sa-loader-bg">
        <img src="https://img.litedev.com/images/loader.svg" class="sa-loader-img" width="36" height="36" alt="loader"/>
    </div>
</template>
<script>
export default {
    data(){
        return{
        }
    }
}
</script>